import {
  UPDATE_JOURNAL_SEVERITIES_LIST,
  TOGGLE_JOURNAL_SEVERITIES_LOADING,
  JOURNAL_SEVERITIES_ERROR,
  JOURNAL_SEVERITIES_UPDATE_TOTAL
} from '../actions/journalSeveritiesActions'

const initState = {
  name: 'Journal Severities',
  severities: {
    loading: true,
    list: [],
    error: null,
    totalRecords: 0
  }
}

const journalSeveritiesReducer = (state = initState, action) => {
  switch (action.type) {
    case UPDATE_JOURNAL_SEVERITIES_LIST:
      return { ...state, severities: { ...state.severities, list: action.payload.value } }
    case JOURNAL_SEVERITIES_UPDATE_TOTAL:
      return { ...state, severities: { ...state.severities, totalRecords: action.payload.value } }
    case TOGGLE_JOURNAL_SEVERITIES_LOADING:
      return { ...state, severities: { ...state.severities, loading: action.payload.value } }
    case JOURNAL_SEVERITIES_ERROR:
      return { ...state, severities: { ...state.severities, error: action.payload.value } }
    default:
      return state
  }
}

export default journalSeveritiesReducer
